import * as React from 'react';

function SvgFilterIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...props}>
      <path d="M2.125 4.25H14.875M4.25 8.5H12.75M6.375 12.75H10.625" stroke="#696969" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export default SvgFilterIcon;
